var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Button, Table, TableCell, TableRow, Typography } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import Toolbar from '@material-ui/core/Toolbar';
import React, { useState, useEffect } from 'react';
import { Container } from '../services/di';
import { handleActionResponse, handleAction } from '../services/actions';
import CircularProgress from '@material-ui/core/CircularProgress';
var useStyles = makeStyles(function (theme) {
    return createStyles({
        box: {
            flexGrow: 1
        }
    });
});
var MultiDetail = function (_a) {
    var modelName = _a.modelName, actions = _a.actions, ids = _a.ids, onCancel = _a.onCancel;
    var classes = useStyles();
    var _b = __read(useState([]), 2), labels = _b[0], setLabels = _b[1];
    var _c = __read(useState({}), 2), loadingRecords = _c[0], setLoadingRecords = _c[1];
    useEffect(function () {
        Container.http.post("/ui/models/" + modelName + "/labels", {
            recordIds: ids
        })
            .then(function (labels) { return setLabels(labels); });
    }, [ids]);
    var handleClick = function (action) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!action.options.batch) return [3 /*break*/, 2];
                    _a = handleActionResponse;
                    return [4 /*yield*/, handleAction(action, {
                            recordIds: ids
                        })];
                case 1:
                    _a.apply(void 0, [_b.sent()]);
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, Promise.all(ids.map(function (recordId) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    loadingRecords[recordId] = true;
                                    _a = handleActionResponse;
                                    return [4 /*yield*/, handleAction(action, {
                                            recordId: recordId
                                        })];
                                case 1:
                                    _a.apply(void 0, [_b.sent()]);
                                    delete loadingRecords[recordId];
                                    setLoadingRecords(loadingRecords);
                                    return [2 /*return*/];
                            }
                        });
                    }); }))];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return React.createElement("div", { style: { width: '40vw' } },
        React.createElement(AppBar, { position: "static" },
            React.createElement(Toolbar, null,
                React.createElement(Box, { className: classes.box },
                    "Vybran\u00E9 polo\u017Eky ",
                    ids.length),
                React.createElement(Button, { color: "inherit", onClick: onCancel }, "Zru\u0161it v\u00FDb\u011Br"))),
        React.createElement("div", { style: { height: '400px', maxHeight: '35vh', overflow: 'auto' } },
            React.createElement(Table, null,
                React.createElement(TableBody, null, labels.map(function (label, index) { return React.createElement(TableRow, { hover: true, key: index },
                    React.createElement(TableCell, null, label.$label),
                    React.createElement(TableCell, null, loadingRecords[label.id] && React.createElement(CircularProgress, { size: 1 }))); })))),
        React.createElement(Box, { p: 1 },
            React.createElement(Typography, null, "Dostupn\u00E9 akce")),
        React.createElement(Box, { p: 1 }, actions.items
            .map(function (action, index) { return React.createElement(Button, { variant: "contained", color: "primary", fullWidth: true, key: index, onClick: function () { return handleClick(action); } }, action.label); })));
};
export default MultiDetail;
//# sourceMappingURL=MultiDetail.js.map